import React from 'react';
import {SvgIcon, SvgIconProps} from "@mui/material";

const ResetIconSvg = (<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.5 15C6.5 16.6811 6.99852 18.3245 7.93251 19.7223C8.8665 21.1202 10.194 22.2096 11.7472 22.853C13.3004 23.4963 15.0094 23.6647 16.6583 23.3367C18.3071 23.0087 19.8217 22.1992 21.0104 21.0104C22.1992 19.8217 23.0087 18.3071 23.3367 16.6583C23.6647 15.0094 23.4963 13.3004 22.853 11.7472C22.2096 10.194 21.1202 8.8665 19.7223 7.93251C18.3245 6.99852 16.6811 6.5 15 6.5H8.5"
            stroke="currentColor"/>
        <path d="M12 10L8.5 6.5L12 3" stroke="currentColor"/>
    </svg>

)
const ResetIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {ResetIconSvg}
    </SvgIcon>
);
export default ResetIcon